module.exports = __webpack_public_path__ + "assets/waterMeterIcon1.41a227c0.svg";